export enum GassClaims {
  DocConsultazione = 'DocConsultazione',
  DocModifica = 'DocModifica',
  DocAnnullamento = 'DocAnnullamento',
  DocDistruzione = 'DocDistruzione',
  DocRiapertura = 'DocRiapertura',
  StampaAllegati = 'StampaAllegati',
  StampaRegistri = 'StampaRegistri',
  AnagIndirizzi = 'AnagIndirizzi',
  AnagUtenti = 'AnagUtenti',
  AnagFascicoli = 'AnagFascicoli',
  AnagClassQualSez = 'AnagClassQualSez',
  Audit = 'Audit',
  CisModifica = 'CanEditCIS',
  DocSpostamento = 'DocSpostamento',
  PassaggioConsegne = 'PassaggioConsegne',
  DocAnnullaOperazione = 'DocAnnullaOperazione'
}
